// @generated by protoc-gen-es v1.0.0 with parameter "target=js+dts,ts_nocheck=false"
// @generated from file pipelines/report_periodontal_status.proto (package com.diagnocat.pipelines, syntax proto3)
/* eslint-disable */

import { proto3 } from "@bufbuild/protobuf";
import { ToothPeriodontalStatus } from "../model/dto_report_periodontal_status_pb.js";

/**
 * @generated from message com.diagnocat.pipelines.TeethPeriodontalStatuses_Update
 */
export const TeethPeriodontalStatuses_Update = proto3.makeMessageType(
  "com.diagnocat.pipelines.TeethPeriodontalStatuses_Update",
  () => [
    { no: 1, name: "PeriodontalStatuses", kind: "message", T: ToothPeriodontalStatus, repeated: true },
  ],
);

